import React, { Component } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import withRouter from '../../../withRouter';
import { PropTypes } from 'prop-types';
import { analyticsClickEvent } from "../../../action/firebaseAnalytics/firebaseAnalytics";
class HomeBannerInactive extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemValue: '',
        }
    }



    render() {

        return (
            <div className="application-banner-home">

                    <div className="inner-content">
                        <div className="top-section-need" style={{ backgroundColor:" #E7E7E7"}}>
                        <h1 className="need-title">
                           How to&nbsp;<img src="images/hummBNPL_WE_Tangerine_RGB_150dpi 1.svg" alt="hummBNPL Logo" />
                        </h1>
                        <p className="need-para mb-2">Shop with humm. Spread the cost of your purchase when buying from any of our partners, both in-store and online.</p>
                        </div>
                        <div className="icon-need-item">
                            <div className="icon--items-app-banner">
                                <div className="icon-monthly">
                                    <div className="icon-circle-app-banner">
                                        <img src="images\user-profile-banner-icon.svg" className="img-fluid" alt="Profile User" />
                                    </div>
                                    <div className="icon-para">
                                        <p>Step 1 - Apply</p>
                                        <span>To start your application, <br />click on the ‘Apply’ button <br />and await our decision.</span>
                                    </div>
                                </div>
                                <div className="icon-monthly">
                                    <div className="icon-circle-app-banner">
                                        <img src="images\ecommerce-banner-icon.svg" className="img-fluid" alt="Shop" />
                                    </div>
                                    <div className="icon-para">
                                        <p>Step 2 - Shop</p>
                                        <span>Choose from our participating <br />merchants online and in-store. <br />Proceed to checkout. </span>
                                    </div>
                                </div>
                                <div className="icon-monthly">
                                    <div className="icon-circle-app-banner">
                                        <img src="images\gift-box-banner-icon.svg" className="img-fluid" alt="Complete Purchase" />
                                    </div>
                                    <div className="icon-para">
                                        <p>Step 3 - Complete Purchase</p>
                                        <span>Choose humm at checkout, <br />select your plan and complete <br />your purchase. </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="top-section-need" style={{ backgroundColor:" #E7E7E7"}}>
                            <div className="info-footer d-flex flex-column"
                            style={{borderTop: "none"}}>                    
                                <button type="button" id="applyButton" className="btn btn-primary" 
                                onClick={() => { 
                                this.props.navigate('/application');
                                analyticsClickEvent('begin_application', '');
                                }}>
                                Apply Now &gt;
                                </button>
                            </div>
                        </div>
                    </div>
            </div>
        );
    }
}

HomeBannerInactive.propTypes = {
    navigate: PropTypes.object
}

export default withRouter(HomeBannerInactive);